import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "scmp-app/components/content/content-item-render/highlight/hoc";
import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import { EntityLink } from "scmp-app/components/entity-link";
import type { homeStoryPackageTailContentItemContent$key } from "scmp-app/queries/__generated__/homeStoryPackageTailContentItemContent.graphql";

import {
  ActionBarContainer,
  Container,
  Headline,
  HeadlineContainer,
  LiveTagContainer,
} from "./styles";

type Props = {
  reference: homeStoryPackageTailContentItemContent$key;
} & ContentItemRenderVariantProps;

const Component = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeStoryPackageTailContentItemContent on Content {
          entityId
          urlAlias
          ...entityLink
          ...hooksContentItemProvidersContent
            @arguments(withHeadline: true, withLiveTag: true, withActionBar: true)
        }
      `,
      reference_,
    );
    const providers = useContentItemProviders(content);

    return (
      <Container className={className} ref={reference}>
        <EntityLink
          onClick={() => onClick?.(content.entityId, content.urlAlias)}
          reference={content}
        >
          <HeadlineContainer>
            <LiveTagContainer>{providers.liveTag()}</LiveTagContainer>
            <Headline>
              {providers.headline({
                hideTooltip: true,
                preferSocialHeadline: true,
                skipHighlight: true,
              })}
            </Headline>
          </HeadlineContainer>
        </EntityLink>
        <ActionBarContainer>
          {providers.actionBar({
            commentVariant: "reverse",
            isBookmarkVisible: false,
            isCommentsVisible: true,
          })}
        </ActionBarContainer>
      </Container>
    );
  },
);

Component.displayName = "ContentItemHomeStoryPackageTail";

export const ContentItemHomeStoryPackageTail = withHighlightedHeadline(Component);
